import { enumEntityModelCode } from '@data-layer/enums/entities';

export const DESC_ENTITY = {
  IM: {
    CODE: enumEntityModelCode.IMPORTER,
    imgSrc: 'importer',
    title: 'LABELS.IMPORTER_INFO',
    titleDesktop: 'ENTITY.IMPORTER',
    subTitle: 'INFO.IM.SUB_TITLE',
    hint: 'INFO.IM.HINT',
    addDetails: 'INFO.IM.ADD_DETAILS',
    tooltip: 'INFO.IM.TOOLTIP',
    addNew: 'INFO.IM.ADD_NEW',
    subTitleHint: 'INFO.IM.SUB_TITLE_HINT',
  },
  CN: {
    code: enumEntityModelCode.CONSIGNEE,
    imgSrc: 'consignee',
    title: 'INFO.CN.TITLE',
    titleDesktop: 'ENTITY.CONSIGNEE',
    subTitle: 'INFO.CN.SUB_TITLE',
    hint: 'INFO.CN.HINT',
    addDetails: 'INFO.BY.ADD_DETAILS',
    tooltip: 'INFO.CN.TOOLTIP',
    addNew: 'INFO.CN.ADD_NEW',
    subTitleHint: 'INFO.CN.SUB_TITLE_HINT',
  },
  BY: {
    code: enumEntityModelCode.BUYER,
    imgSrc: 'buyer',
    title: 'INFO.BY.TITLE',
    titleDesktop: 'LABELS.BUYER',
    subTitle: 'INFO.BY.SUB_TITLE',
    addDetails: 'INFO.BY.ADD_DETAILS',
    addNew: 'INFO.BY.ADD_NEW',
    subTitleHint: 'INFO.BY.SUB_TITLE_HINT',
  },
  ST: {
    code: enumEntityModelCode.SHIP_TO,
    imgSrc: 'shipto',
    title: 'INFO.ST.TITLE',
    titleDesktop: 'INFO.ST.TITLE_DESKTOP',
    subTitle: 'INFO.ST.SUB_TITLE',
    addDetails: 'INFO.BY.ADD_DETAILS',
    addNew: 'INFO.ST.ADD_NEW',
    subTitleHint: 'INFO.ST.SUB_TITLE_HINT',
  },
  SE: {
    code: enumEntityModelCode.SELLER,
    imgSrc: 'seller',
    title: 'INFO.SE.TITLE',
    titleDesktop: 'LABELS.SELLER',
    subTitle: 'INFO.SE.SUB_TITLE',
    subTitleDesktop: 'INFO.SE.SUB_TITLE_DESKTOP',
    addDetails: 'INFO.SE.ADD_DETAILS',
  },
  MF: {
    code: enumEntityModelCode.MANUFACTURER,
    imgSrc: 'manufacturer',
    title: 'INFO.MF.TITLE',
    titleDesktop: 'MANUFACTURER',
    subTitle: 'INFO.MF.SUB_TITLE',
    subTitleDesktop: 'INFO.MF.SUB_TITLE_DESKTOP',
    subTitleHint: 'INFO.MF.SUB_TITLE_HINT',
    addDetails: 'INFO.SE.ADD_DETAILS',
  },
  CS: {
    code: enumEntityModelCode.CONSOLIDATOR,
    imgSrc: 'consolidator',
    title: 'INFO.CS.TITLE',
    titleDesktop: 'INFO.CS.TITLE_DESKTOP',
    subTitle: 'INFO.CS.SUB_TITLE',
    subTitleDesktop: 'INFO.CS.SUB_TITLE_DESKTOP',
    addDetails: 'INFO.SE.ADD_DETAILS',
  },
  LG: {
    code: enumEntityModelCode.STAFFING_LOCATION,
    imgSrc: 'container',
    title: 'INFO.LG.TITLE',
    titleDesktop: 'INFO.LG.TITLE',
    subTitle: 'INFO.LG.SUB_TITLE',
    subTitleDesktop: 'INFO.LG.SUB_TITLE_DESKTOP',
    addDetails: 'INFO.SE.ADD_DETAILS',
  },
  HTS: {
    code: enumEntityModelCode.HTS,
    imgSrc: 'hts',
    title: 'LABELS.INTERNATIONAL_HTS_CODE',
    subTitle: 'INFO.HTS.SUB_TITLE',
    subTitleAttention: 'INFO.HTS.SUB_TITLE_DESKTOP',
    addDetails: 'INFO.HTS.ADD_DETAILS',
  },
  SHIP: {
    code: enumEntityModelCode.SHIP,
    imgSrc: 'vessel',
    title: 'INFO.SHIP.TITLE',
    subTitle: 'INFO.SHIP.SUB_TITLE',
  },
  bond: {
    code: enumEntityModelCode.BOND,
    imgSrc: 'vessel',
    title: 'LABELS.CUSTOMS_BOND',
    subTitle: 'INFO.BN.SUB_TITLE',
    addDetails: 'INFO.BN.ADD_DETAILS',
  },
  PM: {
    code: enumEntityModelCode.PM,
    imgSrc: 'payment',
    title: 'MENU.PAYMENT_METHOD',
    subTitle: 'INFO.PM.SUB_TITLE',
  },
  SUM: {
    title: 'INFO.SUM.TITLE',
    subTitle: 'INFO.SUM.SUB_TITLE',
    action: 'INFO.SUM.ACTION',
  },
  IE: {
    imgSrc: 'bond',
    title: 'INFO.IE.TITLE',
    subTitle: 'INFO.IE.SUB_TITLE',
  },
  BN: {
    imgSrc: 'bond',
    title: 'LABELS.CUSTOMS_BOND',
    subTitle: 'INFO.BN.SUB_TITLE',
    isMissing: 'LABELS.ISF_ENTITY_IS_MISSING',
    purchaseSingleBondCanceled: 'INFO.BN.SINGLE_BOND_PURCHASE_CANCELED',
    purchaseSingleBondCanceling: 'INFO.BN.SINGLE_BOND_PURCHASE_CANCELING',
    purchaseSingleBondRefunded: 'INFO.BN.SINGLE_BOND_PURCHASE_REFUNDED',
    purchaseSingleBondRequested: 'INFO.BN.SINGLE_BOND_PURCHASE_REQUESTED',
    purchaseContinuousBondRequested: 'INFO.BN.CONTINUOUS_BOND_PURCHASE_REQUESTED',
  },
};
